import { render, staticRenderFns } from "./cllection.vue?vue&type=template&id=005e5203&scoped=true&"
import script from "./cllection.vue?vue&type=script&lang=js&"
export * from "./cllection.vue?vue&type=script&lang=js&"
import style0 from "./cllection.vue?vue&type=style&index=0&id=005e5203&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e5203",
  null
  
)

export default component.exports